<template>
    <div class="hero">
        <HeroSection>
            <template #breadcrumb>
                <slot name="breadcrumb">
                    <div class="hero__breadcrumb">
                        <al-breadcrumb test-id="newUserBreadcrumb">
                            <al-breadcrumb-item test-id="userManagement">
                                My Team
                            </al-breadcrumb-item>
                            <al-breadcrumb-item
                                is-current="true"
                                test-id="newUser"
                            >
                                {{ title }}
                            </al-breadcrumb-item>
                        </al-breadcrumb>
                    </div>
                </slot>
            </template>
            
            <template #title>
                <div
                    v-if="subtitle"
                    class="hero__subtitle"
                >
                    <slot name="subtitle">
                        <h2>{{ subtitle }}</h2>
                    </slot>
                </div>
                <slot name="title">
                    <div
                        class="hero__title"
                        :class="{ 'hero__title--has-subtitle': subtitle }"
                    >
                        <h1>{{ title }}</h1>
                    </div>
                </slot>
            </template>

            <template #actions>
                <slot name="actions" />
            </template>
        </HeroSection>
        <Divider />
    </div>
</template>

<script lang="ts" setup>
import { DividerSection as Divider, HeroSection } from '@/components/Commons/UI/molecules';
import '@playvox/almendra/dist/components/breadcrumb';

defineProps({
    searchType: {
        type: String,
        required: false,
        default: 'teamSchedule'
    },
    title: {
        type: String,
        required: false,
        default: ''
    },
    subtitle: {
        type: String,
        required: false,
        default: ''
    }
});
</script>

<style lang="scss">
.hero__title {
  align-items: center;
  display: flex;
  gap: var(--spacing-2, 8px);

  h1 {
    font-family: 'Roboto', sans-serif !important;
    font-weight: 700;
    font-size: 31.25px; /* Default size when no subtitle */
    line-height: 36px;
    letter-spacing: 0px;
    vertical-align: middle;
  }
  
  /* When subtitle exists, make h1 smaller */
  &.hero__title--has-subtitle h1 {
    font-size: 24px;
    padding-top: 16px;
  }
}

.hero__subtitle {
  color: var(--color-gray-50);
  font-weight: bold;

  h2 {
    margin: 0;
    font-family: 'Roboto', sans-serif !important;
    font-weight: 700;
    font-size: 31.25px;
    line-height: 36px;
    letter-spacing: 0px;
    vertical-align: middle;
  }
}
</style>
